/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Cigarette = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M18 12H2v4h16" }],
    ["path", { d: "M22 12v4" }],
    ["path", { d: "M7 12v4" }],
    ["path", { d: "M18 8c0-2.5-2-2.5-2-5" }],
    ["path", { d: "M22 8c0-2.5-2-2.5-2-5" }]
  ]
];

export { Cigarette as default };
//# sourceMappingURL=cigarette.js.map
